<template>
  <div>
    <!--기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
      init-field-name="현장명"
    />

    <!-- 현장정보 -->
    <div class="mt-5">
      <vs-row class="my-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 현장정보</h5>
        </vs-col>
      </vs-row>
      <div class="grid grid-cols-3 gap-x-6 gap-y-4 mt-4">
        <div class="custom-row">
          <div class="label-text mr-4">현장명</div>
          <div v-if="isPrint" class="print-input">
            {{ form.inputB_1 }}
          </div>
          <company-selector
            v-else
            v-model="form.inputB_1"
            class="w-full flex-1"
          />
        </div>
        <div class="custom-row">
          <div class="label-text mr-4">업종</div>

          <div v-if="isPrint" class="print-input">
            {{ form.inputB_2 }}
          </div>
          <ml-input
            :readonly="board.readonly"
            v-else
            v-model="form.inputB_2"
            class="w-full flex-1"
          />
        </div>
        <div class="custom-row">
          <div class="label-text mr-4">소재지</div>
          <div v-if="isPrint" class="print-input">
            {{ form.inputB_3 }}
          </div>
          <ml-input
            :readonly="board.readonly"
            v-else
            v-model="form.inputB_3"
            class="w-full flex-1"
          />
        </div>
      </div>
    </div>

    <!-- 재해자 인적사항 -->
    <div class="mt-5">
      <vs-row class="my-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 재해자 인적사항</h5>
        </vs-col>
      </vs-row>
      <div class="grid grid-cols-3 gap-x-6 gap-y-4 mt-4">
        <div class="custom-row">
          <div class="label-text mr-4">성명</div>
          <div v-if="isPrint" class="print-input">
            {{ form.inputC_1 }}
          </div>
          <ml-input
            :readonly="board.readonly"
            v-else
            v-model="form.inputC_1"
            class="w-full flex-1"
          />
        </div>
        <div class="custom-row">
          <div class="label-text mr-4">생년월일</div>
          <div v-if="isPrint" class="print-input">
            {{ form.inputC_2 }}
          </div>
          <date-selector
            v-else
            class="w-full flex-1"
            v-model="form.inputC_2"
            :readonly="board.readonly"
          />
        </div>
        <div class="custom-row">
          <div class="label-text mr-4">소속</div>
          <div v-if="isPrint" class="print-input">
            {{ form.inputC_3 }}
          </div>
          <ml-input
            :readonly="board.readonly"
            v-else
            v-model="form.inputC_3"
            class="w-full flex-1"
          />
        </div>
      </div>
      <div class="grid grid-cols-3 gap-x-6 gap-y-4 mt-4">
        <div class="custom-row">
          <div class="label-text mr-4">직종</div>
          <div v-if="isPrint" class="print-input">
            {{ form.inputC_4 }}
          </div>
          <ml-input
            :readonly="board.readonly"
            v-else
            v-model="form.inputC_4"
            class="w-full flex-1"
          />
        </div>
        <div class="custom-row">
          <div class="label-text mr-4">연락처</div>
          <div v-if="isPrint" class="print-input">
            {{ form.inputC_5 }}
          </div>
          <ml-input
            :readonly="board.readonly"
            v-else
            v-model="form.inputC_5"
            class="w-full flex-1"
          />
        </div>
        <div class="custom-row">
          <div class="label-text mr-4">입사일자</div>
          <div v-if="isPrint" class="print-input">
            {{ form.inputC_6 }}
          </div>
          <date-selector
            v-else
            class="w-full flex-1"
            v-model="form.inputC_6"
            :readonly="board.readonly"
          />
        </div>
      </div>
    </div>

    <!-- 재해발생 원인분석 및 재발방지 대책 -->
    <div class="mt-5">
      <vs-row class="my-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 재해발생 원인분석 및 재발방지 대책</h5>
        </vs-col>
      </vs-row>
      <div class="grid grid-cols-3 gap-x-6 gap-y-4 mt-4">
        <div class="custom-row">
          <div class="label-text mr-4">재해일시</div>
          <div v-if="isPrint" class="print-input">
            {{ form.inputD_1 }}
          </div>
          <date-selector
            v-else
            class="w-full flex-1"
            v-model="form.inputD_1"
            :readonly="board.readonly"
          />
        </div>
        <div class="custom-row">
          <div class="label-text mr-4">재해장소</div>
          <div v-if="isPrint" class="print-input">
            {{ form.inputD_2 }}
          </div>
          <ml-input
            :readonly="board.readonly"
            v-else
            v-model="form.inputD_2"
            class="w-full flex-1"
          />
        </div>
        <div class="custom-row">
          <div class="label-text mr-4">발생형태</div>
          <div v-if="isPrint" class="print-input">
            {{ form.inputD_3 }}
          </div>
          <training-disaster-class-selector
            v-else
            class="w-full flex-1"
            v-model="form.inputD_3"
            :readonly="board.readonly"
          />
        </div>
      </div>
      <div class="grid grid-cols-3 gap-x-6 gap-y-4 mt-4">
        <div class="custom-row">
          <div class="label-text mr-4">기인물</div>
          <div v-if="isPrint" class="print-input">
            {{ form.inputD_4 }}
          </div>
          <ml-input
            :readonly="board.readonly"
            v-else
            v-model="form.inputD_4"
            class="w-full flex-1"
          />
        </div>
        <div class="custom-row">
          <div class="label-text mr-4">행정조치</div>
          <div v-if="isPrint" class="print-input">
            {{ form.inputD_5 }}
          </div>
          <vs-select
            v-model="form.inputD_5"
            autocomplete
            v-else
            :disabled="board.readonly"
            class="w-full flex-1"
          >
            <vs-select-item text="시정지시" value="시정지시" />
            <vs-select-item text="사용중지" value="사용중지" />
            <vs-select-item
              text="부분·전면작업중지"
              value="부분·전면작업중지"
            />
            <vs-select-item text="기타" value="기타" />
            <vs-select-item text="해당없음" value="해당없음" />
          </vs-select>
        </div>
        <div class="custom-row">
          <div class="label-text mr-4">산업재해조사표 제출일</div>
          <div v-if="isPrint" class="print-input">
            {{ form.inputD_6 }}
          </div>
          <date-selector
            v-else
            class="w-full flex-1"
            v-model="form.inputD_6"
            :readonly="board.readonly"
          />
        </div>
      </div>
      <div class="print-container col-span-12 flex items-start mt-4">
        <div class="label-text mr-4 mt-2">재해발생 개요</div>
        <div v-if="isPrint" class="print-textarea">
          {{ form.inputD_7 }}
        </div>
        <ml-textarea
          v-else
          class="flex-1 w-full"
          rows="5"
          v-model="form.inputD_7"
          :readonly="board.readonly"
        />
      </div>
      <div class="print-container col-span-12 flex items-start">
        <div class="label-text mr-4 mt-2">재해발생 원인</div>
        <div v-if="isPrint" class="print-textarea">
          {{ form.inputD_8 }}
        </div>
        <ml-textarea
          v-else
          class="flex-1 w-full"
          rows="5"
          v-model="form.inputD_8"
          :readonly="board.readonly"
        />
      </div>
      <div class="print-container col-span-12 flex items-start">
        <div class="label-text mr-4 mt-2">재해발생 대책 (단기적 대책)</div>
        <div v-if="isPrint" class="print-textarea">
          {{ form.inputD_9 }}
        </div>
        <ml-textarea
          v-else
          class="flex-1 w-full"
          rows="5"
          v-model="form.inputD_9"
          :readonly="board.readonly"
        />
      </div>
      <div class="print-container col-span-12 flex items-start">
        <div class="label-text mr-4 mt-2">재해발생 대책 (장기적 대책)</div>
        <div v-if="isPrint" class="print-textarea">
          {{ form.inputD_10 }}
        </div>
        <ml-textarea
          v-else
          class="flex-1 w-full"
          rows="5"
          v-model="form.inputD_10"
          :readonly="board.readonly"
        />
      </div>
    </div>

    <!-- 사진대지 -->
    <photo-upload-grid-module
      v-model="form.photoList"
      :is-print="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="점검 현장 사진"
    />

    <!-- 파일첨부 -->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PopupPlanProject from "@/views/project/popup/PopupPlanProject";
import DateSelector from "@/components/selector/DateSelector";
import PopupProjectSetting from "@/views/project/PopupProjectSetting";
import MemberSelector from "@/components/selector/MemberSelector";
import CompanySelector from "@/components/selector/CompanySelector";
import FileUploader from "@/components/FileUploader";
import FileUploadModule from "@/views/modules/FileUploadModule";
import TrainingDisasterClassSelector from "@/components/selector/TrainingDisasterClassSelector";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";

export default {
  components: {
    PhotoUploadGridModule,
    FieldSelectModule,
    FileUploadModule,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    TrainingDisasterClassSelector,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      important: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.summary = {
          중대재해발생_현장명: [],
          중대재해발생_재해형태: [],
        };

        value.summary["중대재해발생_현장명"].push({
          [this.form.stdInfo.field_name]: 1,
        });

        value.summary["중대재해발생_재해형태"].push({
          [this.form.inputD_3]: 1,
        });

        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},

        inputB_1: "",
        inputB_2: "",
        inputB_3: "",

        inputC_1: "",
        inputC_2: "",
        inputC_3: "",
        inputC_4: "",
        inputC_5: "",
        inputC_6: "",

        inputD_1: "",
        inputD_2: "",
        inputD_3: "",
        inputD_4: "",
        inputD_5: "",
        inputD_6: "",
        inputD_7: "",
        inputD_8: "",
        inputD_9: "",
        inputD_10: "",

        photoList: [],
        fileList: [],
      },
    };
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
$w-inpu0: 260px;
$w-inpu1: 220px;
$w-inpu2: 140px;
.center-flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

.bg-1 {
  background-color: #f9f9f9;
  border-bottom: $border;
}

.custom-row {
  align-items: center;
  display: grid;
  width: 100%;
  grid-template-columns: 128px 1fr;
}

.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
  padding-right: 12px;
}

.mt-component-form {
  margin-top: 15px;
}

.text-box {
  line-height: 19px;
  margin-top: 15px;
  border: $border;
}

/* uploaded File */
.form-group {
  border: $border;
  overflow: auto;
  width: 100%;
  /*overflow-x: auto;*/

  &__header {
    height: 80px;
    width: 100%;
    display: flex;

    &-title {
      min-width: $w-inpu2;
      border-left: $border;
      border-bottom: $border;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &-title.title-checked {
      margin: 0;
      min-width: 40px;
      max-width: 40px;
      border-left: none;
      padding-left: 10px;
    }
  }

  &__content {
    width: 100%;
    display: flex;

    &-row {
      min-width: $w-inpu2;
      border-left: $border;
      border-bottom: $border;
      padding: 7px;
    }

    &-row.row-checked {
      margin: 0;
      min-width: 40px;
      max-width: 40px;
      border-left: none;
      padding-left: 10px;
    }

    &-row.row-w2 {
      min-width: $w-inpu1;
    }
  }
}

.row-w1 {
  min-width: $w-inpu1;
}

.row-w0 {
  min-width: $w-inpu0;
}

.bx {
  border-left: $border;
  border-right: $border;
}

.br {
  border-right: $border;
}

.bb {
  border-bottom: $border;
}
</style>
